export default __webpack_public_path__ + "static/cloud_gaming-ce2abcad310993f02facd473a20f2b4a.png";